import { getFullUrl } from 'hubspot-url-utils';

export { renderContexts } from 'academy-common-lib/types/renderContext';

export const allowedOrigins = [
  getFullUrl('app', {
    domainOverride: 'hubspot',
    envOverride: 'prod',
  }),
  getFullUrl('app', {
    domainOverride: 'hubspot',
    envOverride: 'qa',
  }),
  getFullUrl('app', {
    domainOverride: 'hubteam',
    envOverride: 'qa',
  }),
  getFullUrl('app', {
    domainOverride: 'hubteam',
    envOverride: 'prod',
  }),
  getFullUrl('local', {
    domainOverride: 'hubspot',
    envOverride: 'prod',
  }),
  getFullUrl('local', {
    domainOverride: 'hubspot',
    envOverride: 'qa',
  }),
  getFullUrl('local', {
    domainOverride: 'hubteam',
    envOverride: 'prod',
  }),
  getFullUrl('local', {
    domainOverride: 'hubteam',
    envOverride: 'qa',
  }),
  getFullUrl('academy', {
    domainOverride: 'hubspot',
    envOverride: 'prod',
  }),
];
